import classNames from "classnames/bind";
import RichText from "common/blocks/RichText";
import type { Popup } from "common/providers/modal/usePopup";
import type { ResolvedPopup } from "resolvers/data/popupResolver";

import FooterCloseButton from "../common/FooterCloseButton";
import styles from "./RichTextPopup.module.scss";

const cx = classNames.bind(styles);

const buildRichtextPopUp = ({ icon, content, title, centerContent }: ResolvedPopup) => {
    return {
        title,
        titleIcon: icon,
        centerContent: centerContent,
        content: {
            component: () => <RichText {...content} />,
            footerComponent: () => (
                <FooterCloseButton
                    theme="primary"
                    type="popup"
                    className={cx("buttonWrap", centerContent ? "center" : "")}
                >
                    Close
                </FooterCloseButton>
            ),
        },
    } as Popup;
};

export default buildRichtextPopUp;
